/* @generated */
import * as React from "react";
import { fileIconShadowFallbackVar, fileIconContainerFallbackVar } from "../../styles/index.css.esm.js";
const BackgroundFileLarge = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M65 2.5H11C7.76787 2.5 5.26617 3.13845 3.56447 4.39771C1.86277 5.65681 1 7.50807 1 9.9V68.1C1 70.4918 1.86277 72.343 3.56447 73.6023C5.26596 74.8616 7.76766 75.5 11 75.5H65C68.2321 75.5 70.7338 74.8616 72.4355 73.6023C74.1372 72.3432 75 70.4919 75 68.1V9.9C75 7.50823 74.1372 5.65697 72.4355 4.39771C70.734 3.13845 68.2323 2.5 65 2.5Z",
    fill: fileIconShadowFallbackVar
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M65 2H11C7.76787 2 5.26617 2.63844 3.56447 3.89771C1.86277 5.15681 1 7.00807 1 9.4V66.6C1 68.9918 1.86277 70.843 3.56447 72.1023C5.26596 73.3616 7.76766 74 11 74H65C68.2321 74 70.7338 73.3616 72.4355 72.1023C74.1372 70.8432 75 68.9919 75 66.6V9.4C75 7.00823 74.1372 5.15697 72.4355 3.89771C70.734 2.63845 68.2323 2 65 2Z",
    fill: fileIconContainerFallbackVar
  }
));
export {
  BackgroundFileLarge
};
